import type { PermissionCode } from '@/shared/permissions';

/**
 * Promo permission codes — mirror the BFF's `RolePermissionMapper` (plan-pricing-004's RBAC
 * plan): `catalog.promo.view` / `catalog.promo.manage` / `catalog.promo.approve` (a deliberately
 * separate, stricter gate than `manage` — an author cannot rubber-stamp their own submission) and
 * the independent `catalog.budgets.manage` (no `catalog.budgets.view` tier exists; budgets reads
 * also require `manage`).
 */
export const PROMO_PERMISSIONS = {
  promo: {
    view: 'catalog.promo.view',
    manage: 'catalog.promo.manage',
    approve: 'catalog.promo.approve',
  },
  budgets: { manage: 'catalog.budgets.manage' },
} as const satisfies Record<string, Record<string, PermissionCode>>;

export type PromoPermissionArea = keyof typeof PROMO_PERMISSIONS;

/** Flattened list of every promo permission code (for mock sessions / seeding). */
export const ALL_PROMO_PERMISSIONS: PermissionCode[] = Object.values(PROMO_PERMISSIONS).flatMap(
  (area) => Object.values(area),
);
